"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAllPossibleCoverages = exports.withoutCoverages = exports.regular = void 0;
var QuotationUnit_1 = require("../models/QuotationUnit");
var QuotationCoverage_1 = require("../models/QuotationCoverage");
var mockVehicle_1 = __importDefault(require("./mockVehicle"));
var mockTotal_1 = require("./mockTotal");
var mockQuotationCoverageList_1 = __importDefault(require("./mockQuotationCoverageList"));
var mockUnitPackage_1 = __importDefault(require("./mockUnitPackage"));
/**
 * A regular unit
 */
exports.regular = __assign(__assign({}, QuotationUnit_1.makeEmptyQuotationUnit()), { unit: mockVehicle_1.default, coverages: mockQuotationCoverageList_1.default, total: mockTotal_1.withEmptyDiscounts, package: mockUnitPackage_1.default });
/**
 * A unit that contains no coverages
 */
exports.withoutCoverages = __assign(__assign({}, exports.regular), { coverages: [] });
/**
 * A unit that contains all possible coverage configurations:
 * - regular
 * - with deductibles
 * - endorsements
 */
exports.withAllPossibleCoverages = __assign(__assign({}, exports.regular), { coverages: __spreadArrays(exports.regular.coverages, [
        __assign(__assign({}, QuotationCoverage_1.makeEmptyQuotationCoverage()), { coverageId: '006', insuredValue: 10, deductible: 0 }),
    ]) });
//# sourceMappingURL=mockUnits.js.map